

import "./bNotes/bNotes.sass";
import "./pClientExplorer/pClientExplorer.sass";
import "./pProcessRun/pProcessRun.sass";
import "./pProcessNotes/pProcessNotes.sass";

import { pClientExplorerDirective } from './pClientExplorer/pClientExplorer.directive';
import { pProcessRunDirective }     from './pProcessRun/pProcessRun.directive';
import { pProcessNotesDirective }   from "./pProcessNotes/pProcessNotes.directive";
import { WorkService }              from './Work.service';
import { NotesService }             from './Notes.service';
import { StopWatchService }         from './StopWatch.service';

export default angular.module('frontend.work', ["frontend.api", "frontend.auth", "frontend.theme"])
  .directive('pClientExplorer', pClientExplorerDirective)
  .directive('pProcessRun', pProcessRunDirective)
  .directive('pProcessNotes', pProcessNotesDirective)
  .service('Work', WorkService)
  .service('StopWatch', StopWatchService)
  .service('Notes', NotesService);
